import DropList from "./droplist.js";

export default class TownList extends DropList {
    
    constructor ($target, options) {
        
        super($target, options);
        
        $target.keypress(this.keypress.bind(this));
        $target.keyup(this.refresh.bind(this));
        $target.focus(this.refresh.bind(this));
        
        this.lastRequest = null;
    }
    
    refresh (event) {
        
        let cp = $(event.delegateTarget).val().replace(' ', '');
        
        if (/\d{5}/.test(cp)) {
            
            if (this.lastRequest != cp) {

                this.lastRequest = cp;
                this.retrieveMatches({ cp: cp}).done(result => {
                    if (Object.keys(result.matches).length) {
                        super.populate(result.matches); 
                    }
                });
                
            } else if ( !super.isVisible() ) {
                super.show(); 
            }
            
        } else {
            super.hide();
        }
        
    }
    
    keypress(event) {
        if ($(event.delegateTarget).val() == '' && event.which == 13) {
            super.on('reset', event); 
        }
    }
    
    retrieveMatches(configuration) {
        return $.post('core/ajax/ajax_cp_ville.php', $.extend( {}, {
                    cp: 75000,
                    _format: 'json'
                }, configuration)
            );
    }
    
}
